type Input = string | boolean | null | undefined;

export function join(...inputs: Input[]) {
	return [...inputs].filter(c => !!c).join(' ');
}
